<template>
  <div class="top">
    <!-- <h1>{{ msg }}</h1> -->
    <h2>CONTENTS</h2>
    <ul>
      <li>
        <router-link to="/kameneko">かめねこについて</router-link>
      </li>
      <!-- <li>
        <router-link to="/works">works</router-link>
      </li> -->
    </ul>
    <router-link to="/works/techbookfest05">技術書典05 - 「0から始める！簡単FreeNAS構築チュートリアル！」</router-link>
    <p>Other Contents Coming soon...</p>
  </div>
</template>

<script>
export default {
  name: 'top',
  data () {
    return {
      msg: 'www.lab-dev.net'
    }
  }
}
</script>

<style>
@import '../assets/style/style.css';
</style>



// WEBPACK FOOTER //
// src/components/top.vue